<form autocomplete="off" class="p-0" novalidate [formGroup]="personalDetailsForm">
    <div class="col-lg-12 col-md-12">
        <div class="mt-3">
            <div class="mb-2">
                <h3 class="main-content-label "><b>
                        <img alt="Logo" width="20vh" src="../../assets/images/business-card.png"
                            class="mh-45px mrl mt-1 pb-2">
                        Personal Details</b></h3>
            </div>
            <div *ngIf="personalShow" class="row clearfix">
                <div class="col-sm-3" *ngIf="personalDetailsFormArray['StuFirstNameEng'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>
                                    {{personalDetailsFormArray['StuFirstNameEng'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="personalDetailsFormArray['StuFirstNameEng'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="!isFieldEditable('StuFirstNameEng')" matInput formControlName="StuFirstNameEng" placeholder="First Name"
                                    maxlength="100">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuFirstNameEng'].touched && personalDetailsForm.controls['StuFirstNameEng'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuFirstNameEng'].touched && personalDetailsForm.controls['StuFirstNameEng'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <!-- this is middel name  not a fater name-->
                <div class="col-sm-3" *ngIf="personalDetailsFormArray['StuMiddleName'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuMiddleName'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuMiddleName'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="!isFieldEditable('StuMiddleName')"  maxlength="100" matInput placeholder="Middle Name"
                                    formControlName="StuMiddleName">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMiddleName'].touched && personalDetailsForm.controls['StuMiddleName'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMiddleName'].touched && personalDetailsForm.controls['StuMiddleName'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>

                <div class="col-sm-3" *ngIf="personalDetailsFormArray['StuLastNameEng'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuLastNameEng'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuLastNameEng'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="!isFieldEditable('StuLastNameEng')"  maxlength="100" matInput placeholder="Last Name"
                                    formControlName="StuLastNameEng">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuLastNameEng'].touched && personalDetailsForm.controls['StuLastNameEng'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuLastNameEng'].touched && personalDetailsForm.controls['StuLastNameEng'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="personalDetailsFormArray['StuMothNameEng'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuMothNameEng'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuMothNameEng'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input  [readonly]="!isFieldEditable('StuMothNameEng')" maxlength="100" matInput formControlName="StuMothNameEng"
                                    placeholder="Mother Name">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMothNameEng'].touched && personalDetailsForm.controls['StuMothNameEng'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMothNameEng'].touched && personalDetailsForm.controls['StuMothNameEng'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <!-- this is father name -->
                <div class="col-sm-3" *ngIf="personalDetailsFormArray['StuMidNameEng'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuMidNameEng'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuMidNameEng'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="!isFieldEditable('StuMidNameEng')"  maxlength="100" matInput placeholder="Middle Name"
                                    formControlName="StuMidNameEng">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMidNameEng'].touched && personalDetailsForm.controls['StuMidNameEng'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMidNameEng'].touched && personalDetailsForm.controls['StuMidNameEng'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="personalDetailsFormArray['StuFirstNameMar'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuFirstNameMar'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="personalDetailsFormArray['StuFirstNameMar'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input maxlength="100" matInput placeholder="नाव" formControlName="StuFirstNameMar">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuFirstNameMar'].touched && personalDetailsForm.controls['StuFirstNameMar'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuFirstNameMar'].touched && personalDetailsForm.controls['StuFirstNameMar'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="personalDetailsFormArray['StuMidNameMar'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuMidNameMar'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuMidNameMar'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input maxlength="100" matInput placeholder="वडिलांचे नाव"
                                    formControlName="StuMidNameMar">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMidNameMar'].touched && personalDetailsForm.controls['StuMidNameMar'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMidNameMar'].touched && personalDetailsForm.controls['StuMidNameMar'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="personalDetailsFormArray['StuLastNameMar'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuLastNameMar'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuLastNameMar'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input maxlength="100" matInput placeholder="आडनाव" formControlName="StuLastNameMar">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuLastNameMar'].touched && personalDetailsForm.controls['StuLastNameMar'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuLastNameMar'].touched && personalDetailsForm.controls['StuLastNameMar'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3" *ngIf="personalDetailsFormArray['StuMothNameMar'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuMothNameMar'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuMothNameMar'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input maxlength="100" matInput placeholder="आईचे नाव" formControlName="StuMothNameMar">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMothNameMar'].touched && personalDetailsForm.controls['StuMothNameMar'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMothNameMar'].touched && personalDetailsForm.controls['StuMothNameMar'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6" *ngIf="personalDetailsFormArray['StudentFullName'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StudentFullName'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="personalDetailsFormArray['StudentFullName'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="!isFieldEditable('StudentFullName')"  maxlength="100" matInput placeholder="Full Name"
                                    formControlName="StudentFullName" readonly>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StudentFullName'].touched && personalDetailsForm.controls['StudentFullName'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StudentFullName'].touched && personalDetailsForm.controls['StudentFullName'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-6" *ngIf="personalDetailsFormArray['StuFullNameMar'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuFullNameMar'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuFullNameMar'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input maxlength="100" matInput placeholder="नाव" formControlName="StuFullNameMar">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuFullNameMar'].touched && personalDetailsForm.controls['StuFullNameMar'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuFullNameMar'].touched && personalDetailsForm.controls['StuFullNameMar'].errors?.pattern">
                                    Enter Vliad Data.
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="personalDetailsFormArray['StuGender'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuGender'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuGender'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select #select1 class="colorblack" formControlName="StuGender">
                                    <mat-select-filter *ngIf="select1.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdCode'" [array]="genderList"
                                        (filteredReturn)="filteredGenderList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredGenderList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuGender'].touched && personalDetailsForm.controls['StuGender'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="personalDetailsFormArray['StuBirthDate'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <!-- <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>
                                        {{personalDetailsFormArray['StuBirthDate'][0]['FormDisplayName']}}</mat-label>
                                    <input matInput [matDatepicker]="validTill" id="validTill"
                                   [min]="minDate" [max]="currentdate" formControlName="StuBirthDate" (dateChange)="ageCalculate()"
                                    placeholder="DD/MM/YYYY" maxlength="10">
                                  <mat-datepicker-toggle matSuffix [for]="validTill">
                                  </mat-datepicker-toggle>
                                  <mat-datepicker #validTill></mat-datepicker>
                                </mat-form-field> -->
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuBirthDate'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuBirthDate'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="!isFieldEditable('StuBirthDate')"  matInput [matDatepicker]="dob" id="dob" formControlName="StuBirthDate"
                                    (dateChange)="ageCalculate()" maxlength="10" [min]="minDate" [max]="currentdate"
                                    placeholder="DD/MM/YYYY">
                                <mat-datepicker-toggle matSuffix [for]="dob">
                                </mat-datepicker-toggle>
                                <mat-datepicker #dob></mat-datepicker>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuBirthDate'].touched && personalDetailsForm.controls['StuBirthDate'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuBirthDate'].touched && personalDetailsForm.controls['StuBirthDate'].errors?.pattern">
                                    Invalid
                                </mat-error>
                                <!-- <mat-error class="margin_tp" *ngIf="this.personalDetailsForm.get('StuBirthDate').errors?.minIsGreaterThanMax">
                                    Invalid</mat-error> -->

                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="personalDetailsFormArray['StuAge'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuAge'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuAge'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input readonly formControlName="StuAge" matInput placeholder="Age">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuAge'].touched && personalDetailsForm.controls['StuAge'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuAge'].touched && personalDetailsForm.controls['StuAge'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="personalDetailsFormArray['StuBirthPlace'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuBirthPlace'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuBirthPlace'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input maxlength="25" matInput placeholder="Birth Place"
                                    formControlName="StuBirthPlace">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuBirthPlace'].touched && personalDetailsForm.controls['StuBirthPlace'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuBirthPlace'].touched && personalDetailsForm.controls['StuBirthPlace'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="personalDetailsFormArray['StuMaritalStat'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuMaritalStat'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuMaritalStat'][0]['FormRequired']">*</span>
                                </mat-label>

                                <mat-select #select101 class="colorblack" formControlName="StuMaritalStat">
                                    <mat-select-filter *ngIf="select101.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdCode'" [array]="marritalList"
                                        (filteredReturn)="filteredmarritalstatusList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredmarritalstatusList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMaritalStat'].touched && personalDetailsForm.controls['StuMaritalStat'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="personalDetailsFormArray['StuBloodGroup'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuBloodGroup'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuBloodGroup'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select #select102 class="colorblack" formControlName="StuBloodGroup">
                                    <mat-select-filter *ngIf="select102.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="bloodgroupList"
                                        (filteredReturn)="filteredBloodGroupList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredBloodGroupList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuBloodGroup'].touched && personalDetailsForm.controls['StuBloodGroup'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="personalDetailsFormArray['StuMotherTongue'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuMotherTongue'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="personalDetailsFormArray['StuMotherTongue'][0]['FormRequired']">*</span>
                                </mat-label>
                                 <input matInput placeholder="MotherTongue"
                                    formControlName="StuMotherTongue" maxlength="20">
                                <!-- <mat-select #select103 class="colorblack" formControlName="StuMotherTongue">
                                    <mat-select-filter *ngIf="select103.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdCode'" [array]="mothertoungList"
                                        (filteredReturn)="filteredMotherToungList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredMotherToungList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select> -->
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuMotherTongue'].touched && personalDetailsForm.controls['StuMotherTongue'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="personalDetailsFormArray['StuRgNo'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuRgNo'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuRgNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input readonly matInput placeholder="Number" formControlName="StuRgNo">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuRgNo'].touched && personalDetailsForm.controls['StuRgNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuRgNo'].touched && personalDetailsForm.controls['StuRgNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="IsRegStudent && personalDetailsFormArray['StudentRegNo'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StudentRegNo'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StudentRegNo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input [readonly]="!isFieldEditable('StudentRegNo')" matInput placeholder="Number" formControlName="StudentRegNo">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StudentRegNo'].touched && personalDetailsForm.controls['StudentRegNo'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StudentRegNo'].touched && personalDetailsForm.controls['StudentRegNo'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="IsRegStudent && personalDetailsFormArray['StuRegYear'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuRegYear'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuRegYear'][0]['FormRequired']">*</span>
                                </mat-label>
                                <!-- <mat-select placeholder="Student year" class="colorblack" formControlName="StuRegYear">
                                    <mat-option>Select</mat-option>
                                    <mat-option [value]="1">2023</mat-option>
                                    <mat-option [value]="2022">2022</mat-option>
                                    <mat-option [value]="2020">2021</mat-option>
                                    <mat-option [value]="2020">2020</mat-option>
                                </mat-select> -->
                                <mat-select placeholder="Student year" class="colorblack" formControlName="StuRegYear">
                                    <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuRegYear'].touched && personalDetailsForm.controls['StuRegYear'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="personalDetailsFormArray['StuNumber'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuNumber'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuNumber'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input readonly maxlength="10" matInput placeholder="Mobile Number"
                                    formControlName="StuNumber">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuNumber'].touched && personalDetailsForm.controls['StuNumber'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuNumber'].touched && personalDetailsForm.controls['StuNumber'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="personalDetailsFormArray['StuWhatsAppNumber'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <!-- 
                                -->
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuWhatsAppNumber'][0]['FormDisplayName']}}
                                    <span
                                        *ngIf="personalDetailsFormArray['StuWhatsAppNumber'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input maxlength="10" matInput placeholder="WhatsApp Mobile Number"
                                    formControlName="StuWhatsAppNumber">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuWhatsAppNumber'].touched && personalDetailsForm.controls['StuWhatsAppNumber'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuWhatsAppNumber'].touched && personalDetailsForm.controls['StuWhatsAppNumber'].errors?.pattern">
                                    Invalid
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-4" *ngIf="personalDetailsFormArray['EmailID'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['EmailID'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['EmailID'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input readonly matInput placeholder="Email Id" formControlName="EmailID">
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['EmailID'].touched && personalDetailsForm.controls['EmailID'].errors?.required">
                                    Mandatory
                                </mat-error>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['EmailID'].touched && personalDetailsForm.controls['EmailID'].errors?.pattern || personalDetailsForm.controls['EmailID'].errors?.email">
                                    Invalid
                                </mat-error>
                                <!-- <mat-error class="margin_tp"
                                        *ngIf="personalDetailsForm.controls['EmailID'].touched && personalDetailsForm.controls['EmailID'].errors?.email">
                                        Invalid
                                    </mat-error> -->
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <div class="col-sm-2" *ngIf="personalDetailsFormArray['EmailBelongsTo'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['EmailBelongsTo'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['EmailBelongsTo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select formControlName="EmailBelongsTo" placeholder="Personal / Other"
                                    class="colorblack">
                                    <mat-option>Select</mat-option>
                                    <mat-option value="1">Personal</mat-option>
                                    <mat-option value="2">Other</mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['EmailBelongsTo'].touched && personalDetailsForm.controls['EmailBelongsTo'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
                <!-- //to be added again when asked later for other universities too -->
                <div class="col-sm-3" *ngIf="personalDetailsFormArray['StuAdmInfo'][0]['FormVisible']">
                    <div class="form-group">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuAdmInfo'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuAdmInfo'][0]['FormRequired']">*</span>
                                </mat-label>
                                <mat-select matTooltip="From Where Did You Got Our Information?"
                                    formControlName="StuAdmInfo" placeholder="Admission Info" class="colorblack"
                                    #select17>
                                    <mat-select-filter *ngIf="select17.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="AdmInfoCodeList"
                                        (filteredReturn)="filteredListAdmInfoCode =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredListAdmInfoCode" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="personalDetailsForm.controls['StuAdmInfo'].touched && personalDetailsForm.controls['StuAdmInfo'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                    </div>
                </div>
            <!-- this is for roll no prfx hidden-->
                <div class="col-sm-2 " >
                    <div class="form-group" *ngIf="personalDetailsFormArray['StuRgNoPrfx'][0]['FormVisible']">
                        <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>{{personalDetailsFormArray['StuRgNoPrfx'][0]['FormDisplayName']}}
                                    <span *ngIf="personalDetailsFormArray['StuRgNoPrfx'][0]['FormRequired']">*</span>
                                </mat-label>
                                <input readonly matInput placeholder="Number" formControlName="StuRgNoPrfx">
                            </mat-form-field>

                        </div>
                    </div>
                </div>

                <!-- <div class="row">
                    <h6>Please enter your E-mail ID correctly. All further communication regarding Scrutiny,
                        <br> will be communicated through this E-mail only.
                    </h6>
                </div> -->
                <div class="row mb-2 prpl">
                    <div class="col-sm-12">
                        <button type="button" *ngIf="submitButton"
                            class="btn btn-primary btn-icon-text floatright sz fr mt-1" (click)="submit()">
                            <span style="display: contents; align-items: center;">
                                <img width="20%" src="../../assets/images/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button type="button" *ngIf="updateButton" [disabled]="disabled" (click)="Update()"
                            class="btn btn-primary btn-icon-text floatright sz fr mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20%" src="../../assets/images/edit.gif" style="margin-right: 5px;">
                                Update
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>